import {
  OAuthStartRequest,
  OAuthStartResponse,
  OAuthCallbackResponse,
  CalendarProvider,
} from '../types';
import { ApiClient } from '../../../utils/apiClient';
import { handleApiResult } from '../../../utils/apiErrorHandler';

export const oauthService = {
  // Start OAuth flow
  start: async (provider: CalendarProvider, redirectUri?: string): Promise<string> => {
    const response = await ApiClient.post('/calendars/oauth/start/', {
      provider,
      redirect_uri: redirectUri,
      force_consent: provider === 'outlook', // Force consent screen for Outlook
    } as OAuthStartRequest);
    const result = await handleApiResult<OAuthStartResponse>(
      response,
      'Failed to start OAuth flow'
    );
    if (!result.success || !result.data) {
      throw new Error(result.errors?.generalError || 'Failed to start OAuth flow');
    }
    return result.data.auth_url;
  },

  // Handle OAuth callback
  callback: async (code: string, provider?: CalendarProvider): Promise<OAuthCallbackResponse> => {
    const qs = new URLSearchParams({ code });
    if (provider) qs.append('provider', provider);
    const response = await ApiClient.get(`/calendars/oauth/callback/?${qs.toString()}`);
    const result = await handleApiResult<OAuthCallbackResponse>(
      response,
      'Failed to complete OAuth callback'
    );
    if (!result.success || !result.data) {
      throw new Error(result.errors?.generalError || 'Failed to complete OAuth callback');
    }
    return result.data;
  },
};
